import { render, staticRenderFns } from "./MarkMessage.vue?vue&type=template&id=422b31fe"
import script from "./MarkMessage.vue?vue&type=script&lang=js"
export * from "./MarkMessage.vue?vue&type=script&lang=js"
import style0 from "./MarkMessage.vue?vue&type=style&index=0&id=422b31fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports